import Vue from "vue";
const components = require.context("./", true, /\.vue$/);

components.keys().forEach(item => {
  const componentName = components(item).default.name || components(item).name;
  Vue.component(componentName, components(item).default || components(item));
});
